<template>
	<div id="app">
		<div ref="CS" v-html='content'></div>
	</div>
</template>

<script>
	// import HelloWorld from './components/HelloWorld.vue'
	import axios from 'axios'
	export default {
		name: 'app',
		components: {},
		data() {
			return {
				content: '',
				title: {
					

				}
			}
		},
		created(options) {
			
			console.log("location.search.split('=')", location.search.split('&'))
			const params = {};
			// 提取 ? 后的参数部分（若没有 ? 则返回空对象）
			const queryString = location.search.split('?')[1];
			if (queryString) {
				// 按 & 分割参数（处理空参数，如 "a=&b" 或 "a&b"）
				const parts = queryString.split('&');
				
				parts.forEach(part => {
					// 按 = 分割键和值（允许值为空或没有 =）
					const [key, value = ''] = part.split('=');
					// 解码 URL 编码（如空格可能被编码为 %20）
					const decodedKey = decodeURIComponent(key);
					const decodedValue = decodeURIComponent(value);
					params[decodedKey] = decodedValue;
				});
			}

			

			let type = 'user';
			let app='';
			let lang = 'zh-CN';
			let url='https://service.nihaoxiaozhi.com'
			console.log('params',params)
			if(params.type){
				type=params.type
			}
			if(params.lang){
				lang=params.lang
			}
			if(params.url){
				url=params.url
			}
			if(params.app){
				app=params.app
			}
			
			console.log(type,lang)
			this.type = type
			
			axios.get(url+'/api/mini-app/agreement/app', {
					params: {
						type:type,
						source:app
					},
					headers: {
						'Accept-Language': lang // 这里添加自定义头部
					}
				})
				.then((response) => {
					// 处理成功情况
					let content = response.data.data.agreement
					if(params.appname){
						content=content.replace(/轻语/g, params.appname+' ')
					}
					
					this.content = content
					console.log(this.content)
					this.$nextTick(() => {
					      // 通过 ref 获取容器元素
					      const csElement = this.$refs['CS'];
					      if (!csElement) return;
					
					      // 在容器内查询 title 标签
					      const titleTag = csElement.querySelector('title');
					      if (titleTag) {
					        // 获取 title 标签的文本内容
					        const titleContent = titleTag.textContent;
							document.title = titleContent
					        console.log('title 内容：', titleContent); // 输出："这是需要获取的标题内容"
					      } else {
					        console.log('未在 ref="CS" 中找到 title 标签');
					      }
					    });
				})
		}
	}
</script>

<style>
	.text {
		padding: 20rpx 30rpx;
		font-size: 32rpx;
		white-space: pre-wrap;
		text-align: left;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: #2c3e50;
	}
</style>